const getConfig = () => window.__RUNTIME_CONFIG__ || {};

module.exports = Object.freeze({
  ACCOUNT_PAGE_URL: "/account",
  ADDONS_PAGE_URL: "/addons",
  APPOINTMENTS_PAGE_URL: "/appointments",
  DASHBOARD_PAGE_URL: "/",
  EVENT_PAGE_URL: "/events",
  FAQS_PAGE_URL: "/faqs",
  get FRONT_END_HOME_PAGE_URL() {
    return getConfig().FRONT_END_HOME_PAGE_URL || "http://localhost:3000";
  },
  GALLERY_PAGE_URL: "/gallery",
  HOME_PAGE_URL: "/",
  INQUIRIES_PAGE_URL: "/inquiries",
  INVOICES_PAGE_URL: "/invoices",
  RESERVATIONS_PAGE_URL: "/reservations",
  RECEIPTS_PAGE_URL: "/receipts",
  PROFILE_PAGE_URL: "/profile",
  RATE_CONFIG_PAGE_URL: "/rate-config",
  USERS_PAGE_URL: "/users",
});
